/**
 * 空白图片生成工具
 * 用于在编辑列表中插入空白白色背景图片
 */

/**
 * 生成随机 requestId
 * 遵循现有系统的 requestId 生成模式
 */
export function generateBlankRequestId() {
  return 'blank_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

/**
 * 生成空白白色图片的 dataURL
 * @param {number} width - 图片宽度，默认 800
 * @param {number} height - 图片高度，默认 600
 * @returns {string} dataURL 格式的空白图片
 */
export function generateBlankImageDataUrl(width = 800, height = 600) {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d');
  // 填充白色背景
  ctx.fillStyle = '#FFFFFF';
  ctx.fillRect(0, 0, width, height);

  // 添加细微的边框指示这是空白画布
  ctx.strokeStyle = '#E0E0E0';
  ctx.lineWidth = 1;
  ctx.strokeRect(0, 0, width, height);

  return canvas.toDataURL('image/png');
}

/**
 * 创建空白图片对象
 * 符合系统要求的图片对象格式
 * @param {number} width - 图片宽度
 * @param {number} height - 图片高度
 * @returns {Object} 系统兼容的图片对象
 */
export function createBlankImageObject(width = 800, height = 600) {
  const requestId = generateBlankRequestId();
  const dataUrl = generateBlankImageDataUrl(width, height);

  return {
    requestId,
    OriginUrl: dataUrl,
    Url: dataUrl,
    isBlank: true, // 标识这是空白图片
    width,
    height,
    name: `空白图片_${requestId.slice(-6)}`,
    blankCreatedAt: Date.now()
  };
}

/**
 * 检查是否为空白图片
 * @param {Object} image - 图片对象
 * @returns {boolean}
 */
export function isBlankImage(image) {
  return image && image.isBlank === true;
}

export default {
  generateBlankRequestId,
  generateBlankImageDataUrl,
  createBlankImageObject,
  isBlankImage
};